<template>
    <a-layout class="enable-layout">
        <a-row>
            <ProvisioningHeader />
            <div class="enable-content-container">
                <p v-if="isLoading">裝置納管中...</p>
                <p v-else-if="isSuccess">裝置納管成功！</p>
            </div>
            <ModalApiResultMsg
                :visible="responseMsgObj.visible" 
                :title="responseMsgObj.title" 
                :okText="responseMsgObj.okText"
                :cancelText="responseMsgObj.cancelText"
                :msgClass="responseMsgObj.msgClass"
                :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal" 
                :cancelCallback="hideModal"
            >
            <p>{{responseMsgObj.detailText}}</p>
            </ModalApiResultMsg>
        </a-row>
    </a-layout>
</template>

<script>
    import ProvisioningHeader from "../components/deviceProvision/ProvisioningHeader.vue";
    import { agreeEnableApi } from '../api/api';
    import ModalApiResultMsg from "../components/modal/ModalApiResultMsg.vue";
    import { mixinModalMethods } from "../utils/mixins";

    export default {
        name: 'DeviceAgreeEnableContainer',
        components: {
            ProvisioningHeader,
            ModalApiResultMsg,
        },
        mixins: [ mixinModalMethods ],
        data() {
            return {
                isLoading: true,
                isSuccess: false,
                timer: null,
                responseMsgObj: {
                    visible: false,
                    title: '納管錯誤',
                    okText: '確認',
                    cancelText: '',
                    detailText: '',
                    msgClass: 'msg_confirm_modal',
                },
            } 
        },
        mounted() {
            const params = {
                data: this.$route.query.data,
            }

            this.sendAgreeEnable(params);
        },
        methods: {
            async sendAgreeEnable(params) {
                try {
                    const result = await agreeEnableApi(params);
                    console.log('result', result);

                    this.timer = setTimeout(() => {
                        this.isLoading = false;
                        this.combineResMsg(result.status);
                    }, 2000);
                } catch (error) {
                    console.log(error);
                    this.isLoading = false;
                    
                    if (error.response && error.response.status === 403) {
                        // 403 = 此設備已納管
                        this.isSuccess = true; 
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            visible: true,
                            title: '此設備已納管',
                            okText: '',
                            cancelText: '關閉',
                            detailText: '您的設備已經開通完畢',
                            msgClass: 'msg_error_modal',
                        };
                    } else {
                        // 其他 API 錯誤
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            visible: true,
                            title: '系統錯誤',
                            okText: '',
                            cancelText: '',
                            detailText: '系統發生錯誤，請聯繫客服人員',
                            msgClass: 'msg_error_modal',
                        };
                    }
                }
            },
            combineResMsg(status) {
                switch (status) {
                    case 200:
                        this.isSuccess = true; 
                        this.responseMsgObj = { 
                            ...this.responseMsgObj, 
                            title: '裝置納管結果',
                            detailText: '納管驗證成功',
                            okText: '',          // 隱藏確認按鈕
                            cancelText: '關閉',  // 只顯示關閉
                            visible: true, 
                            msgClass: 'msg_confirm_modal' 
                        };
                        break;
                    // 3:設備不存在、4:設備停用
                    case 3:
                    case 4:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            visible: true,
                            title: '裝置不存在',
                            okText: '撥打電話',
                            cancelText: '否',
                            detailText: '查無此裝置資訊，請聯繫客服人員',
                            msgClass: 'msg_error_modal',
                        };
                        break;
                    case 5:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '設備未開通',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    case 6:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '設備過期',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    case 7:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '設備已損壞',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    case 8:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '車輛已納管',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    case 9:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '簡訊驗證失敗',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    case 10:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '簡訊已過期',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    case 11:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '查無車隊資訊',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    case 12:
                        this.responseMsgObj = {
                            ...this.responseMsgObj,
                            detailText: '更新平台納管碼錯誤',
                            visible: true,
                            msgClass: 'msg_confirm_modal'
                        };
                        break;
                    default:
                        break;
                }
            },
        },
        beforeDestroy() {
            clearTimeout(this.timer);
        },
    }
</script>

<style lang="scss" scoped>
.enable-layout {
    padding: 12px;
    height: 100vh;
    .ant-row {
        height: 100%;
        p {
            position: absolute;
            font-size: 16px;
            line-height: 24px;
            color: #343741;
            margin: 0;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
